'use strict'

const formValidation = () => {
	const toastList = $('#toastr-list')
	const messages = {
		objet_manquant: toastList.find('#objet_manquant').val(),
		email_manquant: toastList.find('#email_manquant').val(),
		email_incorrect: toastList.find('#email_incorrect').val(),
		prenom_manquant: toastList.find('#prenom_manquant').val(),
		nom_manquant: toastList.find('#nom_manquant').val(),
		civilite_manquante: toastList.find('#civilite_manquante').val(),
		telephone_manquant: toastList.find('#telephone_manquant').val(),
		cp_manquant: toastList.find('#cp_manquant').val(),
		case_dacceptation: toastList.find('#case_dacceptation').val(),
		tel_incorrect: toastList.find('#telephone_incorrect').val(),
		mail_envoye: toastList.find('#message_bien_envoye').val(),
		mail_erreur: toastList.find('#erreur_denvoi_du_message').val(),
		mail_saved: toastList.find('#contact_sauvegarde_dans_sarbacane').val(),
	}
	const regex = {
		mail: RegExp(
			'^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
		),
		tel: RegExp('^(?:(?:\\+|00)33|0)\\s*[1-9](?:[\\s.-]*\\d{2}){4}$'),
	}
	let proccess = Number(0)
	let proccessVal = Number(0)

	const forms = $('#contactForm, #js-newsletter__form')

	forms.on('mouseenter', function() {
		let form = $(this)

		//  fields
		const fields = {
			page: form.find('#page_name'),
			objet: form.find('#objet'),
			client: form.find('[name="customer"]'),
			nom: form.find('#nom'),
			prenom: form.find('#prenom'),
			civility: form.find('#civility'),
			email: form.find('#email'),
			tel: form.find('#tel'),
			cp: form.find('#cp'),
			check_news: form.find('#check_news'),
			check_contact: form.find('#check_contact'),
			message: form.find('#message'),
		}

		form.find('select, input, option, textarea').on('change', () => {
			proccess = Number(0)
			proccessVal = Number(0)
		})

		let files = []

		// Postuler to 1st input form
		$('.job-card__cta .link').on('click', function(e) {
			e.preventDefault()
			let content =
				$(this).attr('data-title') +
				' ( Réf : ' +
				$(this).attr('data-ref') +
				' )'
			fields.objet.val('').val(content)
		})

		// Prevent "enter' touch press submit form
		$(window).keydown(function(event) {
			if (event.keyCode === 13) {
				event.preventDefault()
				return false
			}
		})

		// Submit Form
		form.on('submit', function(e) {
			e.preventDefault()
			e.stopPropagation()

			// witch form
			let formID = $(this).attr('id')
			let valid = false

			proccessVal++
			if (proccessVal > 1) {
				return false
			}

			let rgpd = {
				newsletter: fields.check_news.is(':checked'),
				contact: fields.check_contact.is(':checked'),
				//offres: fields.check_offre.is(':checked'),
			}

			valid = formValidation(formID)

			// Form validation
			if (!valid) {
				proccess = 0
				valid = null
				return false
			} else {
				// Add loader
				form.find('.js-loader').css('display', 'block')

				let form_data = new FormData()

				// Get values
				console.log({ fields })
				let values = Object.keys(fields).map((key, i) => {
					if (key === 'civility') {
						form_data.append(key, fields[key].val() ? fields[key].val() : '')
					} else if (key === 'check_news' || key === 'check_contact') {
						if (fields[key].length > 0) {
							form_data.append(key, fields[key][0].checked ? 'Oui' : 'Non')
						}
					} else if (key === 'client') {
						let tmp = ''
						fields[key].each(function() {
							tmp = this.checked ? $(this).val() : ''
						})
						form_data.append(key, tmp)
					} else {
						form_data.append(key, fields[key].val())
					}
				})

				// Display the key/value pairs
				for (var pair of form_data.entries()) {
					console.log(pair[0] + ', ' + pair[1])
				}

				// Block looping
				proccess++
				if (proccess === 1) {
					// Ajax send mail
					if (formID !== 'js-newsletter__form') {
						form_data.append('action', 'zz_send_mail')
						form_data.append('form_slug', formID)
						form_data.append('page_id', $('body').attr('data-page-id'))
						form_data.append('page_title', $('body').attr('data-page-title'))

						$.ajax({
							url: ajaxurl,
							type: 'post',
							contentType: false,
							processData: false,
							data: form_data,
							success: function(response) {
								form.find('.js-loader').css('display', 'none')
								toastr.success(messages.mail_envoye)
								proccess = 0
								cleanForm()
							},
							error: function(response) {
								form.find('.js-loader').css('display', 'none')
								toastr.error(messages.mail_erreur)
								proccess = 0
							},
						})
					}

					// Ajax save mail in sarbacane
					if (rgpd.newsletter || rgpd.contact) {
						form_data.append('action', 'zz_save_mail')

						$.ajax({
							url: ajaxurl,
							type: 'post',
							contentType: false,
							processData: false,
							data: form_data,
							success: function(response) {
								form.find('.js-loader').css('display', 'none')
								toastr.success(messages.mail_saved)
								cleanForm()
								proccess = 0
							},
							error: function(response) {
								form.find('.js-loader').css('display', 'none')
								toastr.error(messages.mail_erreur)
								proccess = 0
							},
						})
					}
				}
				return false
			}

			return false
		})

		// Upload files
		form.find('input[type="file"]').on('change', function(e) {
			e.preventDefault()
			const reader = new FileReader()
			const file = e.target.files[0]
			files = e.target.files

			// Update the DOM
			$(this)
				.parent()
				.find('label')
				.html(file.name)

			reader.readAsDataURL(file)
		})

		/**
		 * Form validation for candidatures
		 * @returns {boolean}
		 */
		const formValidation = formID => {
			let valid = true

			if (fields.client.length > 0) {
				console.log(
					fields.client,
					fields.client[0].checked,
					fields.client[1].checked
				)
				if (!fields.client[0].checked && !fields.client[1].checked) {
					fields.client.each(function() {
						$(this)
							.closest('label')
							.find('.checkmark')
							.addClass('invalid')
					})
					valid = false
				}
			}

			if (!fields.email.val()) {
				fields.email.addClass('invalid')
				toastr.error(messages.email_manquant)
				valid = false
			} else if (!regex.mail.test(fields.email.val())) {
				fields.email.addClass('invalid')
				toastr.error(messages.email_incorrect)
				valid = false
			}

			if (formID === 'js-newsletter__form') {
				if (!fields.check_news[0].checked) {
					toastr.error(messages.case_dacceptation)
					valid = false
				}
			}

			if (formID !== 'js-newsletter__form') {
				if (!fields.nom.val()) {
					fields.nom.addClass('invalid')
					toastr.error(messages.nom_manquant)
					valid = false
				}

				if (!fields.prenom.val()) {
					fields.prenom.addClass('invalid')
					toastr.error(messages.prenom_manquant)
					valid = false
				}

				if (!fields.civility.val()) {
					fields.civility.addClass('invalid')
					toastr.error(messages.civilite_manquante)
					valid = false
				}

				if (!fields.tel.val()) {
					fields.tel.addClass('invalid')
					toastr.error(messages.telephone_manquant)
					valid = false
				} else if (!regex.tel.test(fields.tel.val())) {
					fields.tel.addClass('invalid')
					toastr.error(messages.tel_incorrect)
					valid = false
				}

				if (!fields.cp.val()) {
					fields.cp.addClass('invalid')
					toastr.error(messages.cp_manquant)
					valid = false
				}
			}

			return valid // return the valid status
		}

		/**
		 * Clean Form
		 */
		const cleanForm = () => {
			form.find('input, textarea').each(function() {
				if (
					$(this).attr('type') === 'checkbox' ||
					$(this).attr('type') === 'radio'
				) {
					this.checked = false
				} else if ($(this).attr('type') === 'file') {
					$(this)
						.parent()
						.find('label')
						.text($(this).attr('placeholder'))
				} else {
					$(this).val('')
				}
			})
			form.find('select').each(function() {
				this.selectedIndex = 0
			})
		}

		/**
		 * Check if customer
		 */
		$('input[name="customer"]').on('change', function() {
			let thisForm = $(this).closest('form')
			let checkboxSelector = '#check_contact'
			if (thisForm.attr('id') === 'js-newsletter__form') {
				checkboxSelector = '#check_news'
			}

			thisForm
				.find('.radio')
				.find('.checkmark')
				.removeClass('invalid')

			if ($(this).val() === 'Oui') {
				thisForm.find(checkboxSelector)[0].checked = true
				thisForm
					.find(checkboxSelector)
					.parent()
					.css('display', 'none')

				thisForm.find('.disclamer-oui').css('display', 'block')
				thisForm.find('.disclamer-non').css('display', 'none')
			} else {
				thisForm.find(checkboxSelector)[0].checked = false
				thisForm
					.find(checkboxSelector)
					.parent()
					.css('display', 'flex')

				thisForm.find('.disclamer-oui').css('display', 'none')
				thisForm.find('.disclamer-non').css('display', 'block')
			}
		})
	})
}

export { formValidation }
